/* tslint:disable */
/* eslint-disable */
/**
 * Work File Import API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const ActionEnum = {
    None: 'none',
    BoltRegistration: 'boltRegistration',
    BoltReferenceMeasurement: 'boltReferenceMeasurement',
    SensorCalibration: 'sensorCalibration',
    BoltAssignment: 'boltAssignment',
    BoltElongationMeasurement: 'boltElongationMeasurement'
} as const;

export type ActionEnum = typeof ActionEnum[keyof typeof ActionEnum];


/**
 * 
 * @export
 * @interface ActionLineResponseDto
 */
export interface ActionLineResponseDto {
    /**
     * 
     * @type {ActionEnum}
     * @memberof ActionLineResponseDto
     */
    'action': ActionEnum;
    /**
     * 
     * @type {{ [key: string]: JsonNode; }}
     * @memberof ActionLineResponseDto
     */
    'payload': { [key: string]: JsonNode; } | null;
    /**
     * 
     * @type {string}
     * @memberof ActionLineResponseDto
     */
    'actionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionLineResponseDto
     */
    'timeOfAction': string;
    /**
     * 
     * @type {string}
     * @memberof ActionLineResponseDto
     */
    'localId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionLineResponseDto
     */
    'user': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionLineResponseDto
     */
    'entityId'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CompensatingAction = {
    ManuelResolve: 'manuelResolve',
    MoveToEarliestAvailable: 'moveToEarliestAvailable',
    MoveToEnd: 'moveToEnd',
    RestoreBoltConnection: 'restoreBoltConnection',
    UseOtherBoltConnection: 'useOtherBoltConnection',
    InvalidateTag: 'invalidateTag'
} as const;

export type CompensatingAction = typeof CompensatingAction[keyof typeof CompensatingAction];


/**
 * 
 * @export
 * @interface ConflictResolutionResponseDto
 */
export interface ConflictResolutionResponseDto {
    /**
     * 
     * @type {CompensatingAction}
     * @memberof ConflictResolutionResponseDto
     */
    'compensatingAction'?: CompensatingAction;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ConflictResolutionResponseDto
     */
    'parameters'?: { [key: string]: string; } | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ConflictType = {
    None: 'none',
    UnkownConflict: 'unkownConflict',
    IndexConflict: 'indexConflict',
    BoltConnectionNotFound: 'boltConnectionNotFound',
    DublicateTag: 'dublicateTag'
} as const;

export type ConflictType = typeof ConflictType[keyof typeof ConflictType];


/**
 * 
 * @export
 * @interface JsonNode
 */
export interface JsonNode {
    /**
     * 
     * @type {JsonNodeOptions}
     * @memberof JsonNode
     */
    'options'?: JsonNodeOptions;
    /**
     * 
     * @type {JsonNode}
     * @memberof JsonNode
     */
    'parent'?: JsonNode;
    /**
     * 
     * @type {JsonNode}
     * @memberof JsonNode
     */
    'root'?: JsonNode;
}
/**
 * 
 * @export
 * @interface JsonNodeOptions
 */
export interface JsonNodeOptions {
    /**
     * 
     * @type {boolean}
     * @memberof JsonNodeOptions
     */
    'propertyNameCaseInsensitive'?: boolean;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface ResolveWorkFileConflictRequestDto
 */
export interface ResolveWorkFileConflictRequestDto {
    /**
     * 
     * @type {CompensatingAction}
     * @memberof ResolveWorkFileConflictRequestDto
     */
    'compensatingAction'?: CompensatingAction;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ResolveWorkFileConflictRequestDto
     */
    'parameters'?: { [key: string]: string; } | null;
}


/**
 * 
 * @export
 * @interface WorkFileChunkDto
 */
export interface WorkFileChunkDto {
    /**
     * 
     * @type {number}
     * @memberof WorkFileChunkDto
     */
    'chunkId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkFileChunkDto
     */
    'blobName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkFileChunkDto
     */
    'recordCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileChunkDto
     */
    'uncompressedBytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileChunkDto
     */
    'minOffsetRecord'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileChunkDto
     */
    'maxOffsetRecord'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkFileChunkDto
     */
    'etag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkFileChunkDto
     */
    'sha256'?: string | null;
}
/**
 * 
 * @export
 * @interface WorkFileChunkingDto
 */
export interface WorkFileChunkingDto {
    /**
     * 
     * @type {number}
     * @memberof WorkFileChunkingDto
     */
    'maxRecordsPerChunk'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileChunkingDto
     */
    'maxUncompressedBytesPerChunk'?: number;
}
/**
 * 
 * @export
 * @interface WorkFileConflictResponseDto
 */
export interface WorkFileConflictResponseDto {
    /**
     * 
     * @type {string}
     * @memberof WorkFileConflictResponseDto
     */
    'conflictId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkFileConflictResponseDto
     */
    'actionId'?: string | null;
    /**
     * 
     * @type {ActionLineResponseDto}
     * @memberof WorkFileConflictResponseDto
     */
    'conflictingLine'?: ActionLineResponseDto;
    /**
     * 
     * @type {ConflictType}
     * @memberof WorkFileConflictResponseDto
     */
    'type'?: ConflictType;
    /**
     * 
     * @type {string}
     * @memberof WorkFileConflictResponseDto
     */
    'occurredAtUtc'?: string;
    /**
     * 
     * @type {ConflictResolutionResponseDto}
     * @memberof WorkFileConflictResponseDto
     */
    'resolution'?: ConflictResolutionResponseDto;
}


/**
 * 
 * @export
 * @interface WorkFileFullResponseDto
 */
export interface WorkFileFullResponseDto {
    /**
     * 
     * @type {string}
     * @memberof WorkFileFullResponseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkFileFullResponseDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkFileFullResponseDto
     */
    'generatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkFileFullResponseDto
     */
    'generatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkFileFullResponseDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkFileFullResponseDto
     */
    'uploadedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkFileFullResponseDto
     */
    'uploadedBy'?: string | null;
    /**
     * 
     * @type {WorkFileStatuses}
     * @memberof WorkFileFullResponseDto
     */
    'status'?: WorkFileStatuses;
    /**
     * 
     * @type {WorkFileProgressDto}
     * @memberof WorkFileFullResponseDto
     */
    'progress'?: WorkFileProgressDto;
    /**
     * 
     * @type {WorkFileManifestDto}
     * @memberof WorkFileFullResponseDto
     */
    'manifest'?: WorkFileManifestDto;
}


/**
 * 
 * @export
 * @interface WorkFileManifestDto
 */
export interface WorkFileManifestDto {
    /**
     * 
     * @type {string}
     * @memberof WorkFileManifestDto
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkFileManifestDto
     */
    'compression'?: string | null;
    /**
     * 
     * @type {WorkFileChunkingDto}
     * @memberof WorkFileManifestDto
     */
    'chunking'?: WorkFileChunkingDto;
    /**
     * 
     * @type {WorkFileTotalsDto}
     * @memberof WorkFileManifestDto
     */
    'totals'?: WorkFileTotalsDto;
    /**
     * 
     * @type {Array<WorkFileChunkDto>}
     * @memberof WorkFileManifestDto
     */
    'chunks'?: Array<WorkFileChunkDto> | null;
}
/**
 * 
 * @export
 * @interface WorkFileProgressDto
 */
export interface WorkFileProgressDto {
    /**
     * 
     * @type {string}
     * @memberof WorkFileProgressDto
     */
    'currentChunk'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkFileProgressDto
     */
    'actionsProcessed'?: number;
}
/**
 * 
 * @export
 * @interface WorkFileSimpleResponseDto
 */
export interface WorkFileSimpleResponseDto {
    /**
     * 
     * @type {string}
     * @memberof WorkFileSimpleResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkFileSimpleResponseDto
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkFileSimpleResponseDto
     */
    'generatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof WorkFileSimpleResponseDto
     */
    'generatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof WorkFileSimpleResponseDto
     */
    'uploadedAt': string;
    /**
     * 
     * @type {string}
     * @memberof WorkFileSimpleResponseDto
     */
    'uploadedBy': string;
    /**
     * 
     * @type {WorkFileStatuses}
     * @memberof WorkFileSimpleResponseDto
     */
    'status': WorkFileStatuses;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDto
     */
    'totalRecords': number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDto
     */
    'processedRecords': number;
    /**
     * 
     * @type {Array<WorkFileConflictResponseDto>}
     * @memberof WorkFileSimpleResponseDto
     */
    'unresolvedConflicts': Array<WorkFileConflictResponseDto>;
}


/**
 * 
 * @export
 * @interface WorkFileSimpleResponseDtoPageDto
 */
export interface WorkFileSimpleResponseDtoPageDto {
    /**
     * 
     * @type {Array<WorkFileSimpleResponseDto>}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'items': Array<WorkFileSimpleResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'skip': number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'take': number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'pageNumber': number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'hasNextPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'isFirstPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkFileSimpleResponseDtoPageDto
     */
    'isLastPage': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WorkFileStatuses = {
    Unknown: 'unknown',
    Uploading: 'uploading',
    ReadyForProcessing: 'readyForProcessing',
    Processing: 'processing',
    Conflict: 'conflict',
    Error: 'error',
    Success: 'success'
} as const;

export type WorkFileStatuses = typeof WorkFileStatuses[keyof typeof WorkFileStatuses];


/**
 * 
 * @export
 * @interface WorkFileTotalsDto
 */
export interface WorkFileTotalsDto {
    /**
     * 
     * @type {number}
     * @memberof WorkFileTotalsDto
     */
    'chunkCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileTotalsDto
     */
    'recordCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkFileTotalsDto
     */
    'uncompressedBytes'?: number;
}

/**
 * WorkFileImportApi - axios parameter creator
 * @export
 */
export const WorkFileImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWorkFile: async (id: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadWorkFile', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('downloadWorkFile', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileById: async (id: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkFileById', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getWorkFileById', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} actionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileConflictByActionId: async (id: string, actionId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkFileConflictByActionId', 'id', id)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('getWorkFileConflictByActionId', 'actionId', actionId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getWorkFileConflictByActionId', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import/{id}/conflicts/by-action/{actionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"actionId"}}`, encodeURIComponent(String(actionId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} conflictId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileConflictById: async (id: string, conflictId: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkFileConflictById', 'id', id)
            // verify required parameter 'conflictId' is not null or undefined
            assertParamExists('getWorkFileConflictById', 'conflictId', conflictId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getWorkFileConflictById', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import/{id}/conflicts/{conflictId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"conflictId"}}`, encodeURIComponent(String(conflictId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileConflicts: async (id: string, tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkFileConflicts', 'id', id)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getWorkFileConflicts', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import/{id}/conflicts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {string} [uploadedAtFrom] 
         * @param {string} [uploadedAtTo] 
         * @param {string} [generatedAtFrom] 
         * @param {string} [generatedAtTo] 
         * @param {WorkFileStatuses} [status] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFiles: async (tenantId: string, sortBy?: string, ascending?: boolean, uploadedAtFrom?: string, uploadedAtTo?: string, generatedAtFrom?: string, generatedAtTo?: string, status?: WorkFileStatuses, skip?: number, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getWorkFiles', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['Ascending'] = ascending;
            }

            if (uploadedAtFrom !== undefined) {
                localVarQueryParameter['UploadedAtFrom'] = (uploadedAtFrom as any instanceof Date) ?
                    (uploadedAtFrom as any).toISOString() :
                    uploadedAtFrom;
            }

            if (uploadedAtTo !== undefined) {
                localVarQueryParameter['UploadedAtTo'] = (uploadedAtTo as any instanceof Date) ?
                    (uploadedAtTo as any).toISOString() :
                    uploadedAtTo;
            }

            if (generatedAtFrom !== undefined) {
                localVarQueryParameter['GeneratedAtFrom'] = (generatedAtFrom as any instanceof Date) ?
                    (generatedAtFrom as any).toISOString() :
                    generatedAtFrom;
            }

            if (generatedAtTo !== undefined) {
                localVarQueryParameter['GeneratedAtTo'] = (generatedAtTo as any instanceof Date) ?
                    (generatedAtTo as any).toISOString() :
                    generatedAtTo;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} conflictId 
         * @param {string} tenantId 
         * @param {ResolveWorkFileConflictRequestDto} [resolveWorkFileConflictRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWorkFileConflict: async (id: string, conflictId: string, tenantId: string, resolveWorkFileConflictRequestDto?: ResolveWorkFileConflictRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolveWorkFileConflict', 'id', id)
            // verify required parameter 'conflictId' is not null or undefined
            assertParamExists('resolveWorkFileConflict', 'conflictId', conflictId)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('resolveWorkFileConflict', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import/{id}/conflicts/{conflictId}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"conflictId"}}`, encodeURIComponent(String(conflictId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveWorkFileConflictRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWorkFile: async (tenantId: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('uploadWorkFile', 'tenantId', tenantId)
            const localVarPath = `/{tenantId}/workfile-import/v1/work-file-import/upload`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkFileImportApi - functional programming interface
 * @export
 */
export const WorkFileImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkFileImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadWorkFile(id: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadWorkFile(id, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.downloadWorkFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkFileById(id: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkFileFullResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkFileById(id, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.getWorkFileById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} actionId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkFileConflictByActionId(id: string, actionId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkFileConflictResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkFileConflictByActionId(id, actionId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.getWorkFileConflictByActionId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} conflictId 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkFileConflictById(id: string, conflictId: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkFileConflictResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkFileConflictById(id, conflictId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.getWorkFileConflictById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkFileConflicts(id: string, tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkFileConflictResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkFileConflicts(id, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.getWorkFileConflicts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [sortBy] 
         * @param {boolean} [ascending] 
         * @param {string} [uploadedAtFrom] 
         * @param {string} [uploadedAtTo] 
         * @param {string} [generatedAtFrom] 
         * @param {string} [generatedAtTo] 
         * @param {WorkFileStatuses} [status] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkFiles(tenantId: string, sortBy?: string, ascending?: boolean, uploadedAtFrom?: string, uploadedAtTo?: string, generatedAtFrom?: string, generatedAtTo?: string, status?: WorkFileStatuses, skip?: number, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkFileSimpleResponseDtoPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkFiles(tenantId, sortBy, ascending, uploadedAtFrom, uploadedAtTo, generatedAtFrom, generatedAtTo, status, skip, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.getWorkFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} conflictId 
         * @param {string} tenantId 
         * @param {ResolveWorkFileConflictRequestDto} [resolveWorkFileConflictRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveWorkFileConflict(id: string, conflictId: string, tenantId: string, resolveWorkFileConflictRequestDto?: ResolveWorkFileConflictRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkFileConflictResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveWorkFileConflict(id, conflictId, tenantId, resolveWorkFileConflictRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.resolveWorkFileConflict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadWorkFile(tenantId: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkFileFullResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadWorkFile(tenantId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkFileImportApi.uploadWorkFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkFileImportApi - factory interface
 * @export
 */
export const WorkFileImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkFileImportApiFp(configuration)
    return {
        /**
         * 
         * @param {WorkFileImportApiDownloadWorkFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWorkFile(requestParameters: WorkFileImportApiDownloadWorkFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadWorkFile(requestParameters.id, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkFileImportApiGetWorkFileByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileById(requestParameters: WorkFileImportApiGetWorkFileByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkFileFullResponseDto> {
            return localVarFp.getWorkFileById(requestParameters.id, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkFileImportApiGetWorkFileConflictByActionIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileConflictByActionId(requestParameters: WorkFileImportApiGetWorkFileConflictByActionIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkFileConflictResponseDto> {
            return localVarFp.getWorkFileConflictByActionId(requestParameters.id, requestParameters.actionId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkFileImportApiGetWorkFileConflictByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileConflictById(requestParameters: WorkFileImportApiGetWorkFileConflictByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkFileConflictResponseDto> {
            return localVarFp.getWorkFileConflictById(requestParameters.id, requestParameters.conflictId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkFileImportApiGetWorkFileConflictsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFileConflicts(requestParameters: WorkFileImportApiGetWorkFileConflictsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkFileConflictResponseDto>> {
            return localVarFp.getWorkFileConflicts(requestParameters.id, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkFileImportApiGetWorkFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkFiles(requestParameters: WorkFileImportApiGetWorkFilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkFileSimpleResponseDtoPageDto> {
            return localVarFp.getWorkFiles(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.uploadedAtFrom, requestParameters.uploadedAtTo, requestParameters.generatedAtFrom, requestParameters.generatedAtTo, requestParameters.status, requestParameters.skip, requestParameters.take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkFileImportApiResolveWorkFileConflictRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWorkFileConflict(requestParameters: WorkFileImportApiResolveWorkFileConflictRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkFileConflictResponseDto> {
            return localVarFp.resolveWorkFileConflict(requestParameters.id, requestParameters.conflictId, requestParameters.tenantId, requestParameters.resolveWorkFileConflictRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkFileImportApiUploadWorkFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWorkFile(requestParameters: WorkFileImportApiUploadWorkFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkFileFullResponseDto> {
            return localVarFp.uploadWorkFile(requestParameters.tenantId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for downloadWorkFile operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiDownloadWorkFileRequest
 */
export interface WorkFileImportApiDownloadWorkFileRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiDownloadWorkFile
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiDownloadWorkFile
     */
    readonly tenantId: string
}

/**
 * Request parameters for getWorkFileById operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiGetWorkFileByIdRequest
 */
export interface WorkFileImportApiGetWorkFileByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileById
     */
    readonly tenantId: string
}

/**
 * Request parameters for getWorkFileConflictByActionId operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiGetWorkFileConflictByActionIdRequest
 */
export interface WorkFileImportApiGetWorkFileConflictByActionIdRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflictByActionId
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflictByActionId
     */
    readonly actionId: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflictByActionId
     */
    readonly tenantId: string
}

/**
 * Request parameters for getWorkFileConflictById operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiGetWorkFileConflictByIdRequest
 */
export interface WorkFileImportApiGetWorkFileConflictByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflictById
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflictById
     */
    readonly conflictId: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflictById
     */
    readonly tenantId: string
}

/**
 * Request parameters for getWorkFileConflicts operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiGetWorkFileConflictsRequest
 */
export interface WorkFileImportApiGetWorkFileConflictsRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflicts
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFileConflicts
     */
    readonly tenantId: string
}

/**
 * Request parameters for getWorkFiles operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiGetWorkFilesRequest
 */
export interface WorkFileImportApiGetWorkFilesRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly sortBy?: string

    /**
     * 
     * @type {boolean}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly ascending?: boolean

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly uploadedAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly uploadedAtTo?: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly generatedAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly generatedAtTo?: string

    /**
     * 
     * @type {WorkFileStatuses}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly status?: WorkFileStatuses

    /**
     * 
     * @type {number}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof WorkFileImportApiGetWorkFiles
     */
    readonly take?: number
}

/**
 * Request parameters for resolveWorkFileConflict operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiResolveWorkFileConflictRequest
 */
export interface WorkFileImportApiResolveWorkFileConflictRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiResolveWorkFileConflict
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiResolveWorkFileConflict
     */
    readonly conflictId: string

    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiResolveWorkFileConflict
     */
    readonly tenantId: string

    /**
     * 
     * @type {ResolveWorkFileConflictRequestDto}
     * @memberof WorkFileImportApiResolveWorkFileConflict
     */
    readonly resolveWorkFileConflictRequestDto?: ResolveWorkFileConflictRequestDto
}

/**
 * Request parameters for uploadWorkFile operation in WorkFileImportApi.
 * @export
 * @interface WorkFileImportApiUploadWorkFileRequest
 */
export interface WorkFileImportApiUploadWorkFileRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkFileImportApiUploadWorkFile
     */
    readonly tenantId: string

    /**
     * 
     * @type {File}
     * @memberof WorkFileImportApiUploadWorkFile
     */
    readonly file?: File
}

/**
 * WorkFileImportApi - object-oriented interface
 * @export
 * @class WorkFileImportApi
 * @extends {BaseAPI}
 */
export class WorkFileImportApi extends BaseAPI {
    /**
     * 
     * @param {WorkFileImportApiDownloadWorkFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public downloadWorkFile(requestParameters: WorkFileImportApiDownloadWorkFileRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).downloadWorkFile(requestParameters.id, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkFileImportApiGetWorkFileByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public getWorkFileById(requestParameters: WorkFileImportApiGetWorkFileByIdRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).getWorkFileById(requestParameters.id, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkFileImportApiGetWorkFileConflictByActionIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public getWorkFileConflictByActionId(requestParameters: WorkFileImportApiGetWorkFileConflictByActionIdRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).getWorkFileConflictByActionId(requestParameters.id, requestParameters.actionId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkFileImportApiGetWorkFileConflictByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public getWorkFileConflictById(requestParameters: WorkFileImportApiGetWorkFileConflictByIdRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).getWorkFileConflictById(requestParameters.id, requestParameters.conflictId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkFileImportApiGetWorkFileConflictsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public getWorkFileConflicts(requestParameters: WorkFileImportApiGetWorkFileConflictsRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).getWorkFileConflicts(requestParameters.id, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkFileImportApiGetWorkFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public getWorkFiles(requestParameters: WorkFileImportApiGetWorkFilesRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).getWorkFiles(requestParameters.tenantId, requestParameters.sortBy, requestParameters.ascending, requestParameters.uploadedAtFrom, requestParameters.uploadedAtTo, requestParameters.generatedAtFrom, requestParameters.generatedAtTo, requestParameters.status, requestParameters.skip, requestParameters.take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkFileImportApiResolveWorkFileConflictRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public resolveWorkFileConflict(requestParameters: WorkFileImportApiResolveWorkFileConflictRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).resolveWorkFileConflict(requestParameters.id, requestParameters.conflictId, requestParameters.tenantId, requestParameters.resolveWorkFileConflictRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkFileImportApiUploadWorkFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkFileImportApi
     */
    public uploadWorkFile(requestParameters: WorkFileImportApiUploadWorkFileRequest, options?: RawAxiosRequestConfig) {
        return WorkFileImportApiFp(this.configuration).uploadWorkFile(requestParameters.tenantId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



